<template>
  <gh-table-page :show-tabs="false" ref="table" :args-query="argsQueryType" :tabs="tabs"
    module="mes.business.mdl.material.service" sort-by="Id" cls="MaterialTypeService" ::show-tabs="true"
    @save-after="$refs.navigation.query()" @delete-after="$refs.navigation.query()" :before-save="beforeSave">
    <template #area_left>
      <material-type-navigation ref="navigation" :show-toolbar="true" v-model="curentMaterialType" expand-level="2">
      </material-type-navigation>
    </template>
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="argsQueryType.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
  </gh-table-page>






</template>

<style>

</style>

<script>
  import Index from "./index.ts";
  export default Index;
</script>